import type { FormikProps } from 'formik'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import type { SettingsResponse } from '../../interfaces'
import { VideoSettingsLayout } from '../../layouts/Settings'

const VideoSettingsPage = (
  form: FormikProps<SettingsResponse>,
): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Video Settings</title>
      <meta name="description" content="Video Settings page" />
    </Helmet>
    <VideoSettingsLayout {...form} />
  </React.Fragment>
)

export default VideoSettingsPage
